import { Locale } from 'date-fns';
import { es, enGB, ca, gl, pt, de, fr } from 'date-fns/locale';
import {
    PickersInputLocaleText,
    esES as muiEsES,
    enUS as muiEnUS,
    caES as muiCaES,
    ptPT as muiPtPT,
    deDE as muiDeDE,
    frFR as muiFrFR,
} from '@mui/x-date-pickers/locales';

// Map of language keys to date-fns locales
const localeMap: Record<string, Locale> = {
    es,
    en: enGB,
    cl: es, // Chilean Spanish uses Spanish locale
    ca,
    gl,
    pt,
    de,
    fr,
    mx: es, // Mexican Spanish uses Spanish locale
};

// Map of language keys to MUI X date picker locale texts
const muiLocaleTextMap: Record<string, PickersInputLocaleText> = {
    es: muiEsES.components.MuiLocalizationProvider.defaultProps.localeText,
    en: muiEnUS.components.MuiLocalizationProvider.defaultProps.localeText,
    cl: muiEsES.components.MuiLocalizationProvider.defaultProps.localeText,
    ca: muiCaES.components.MuiLocalizationProvider.defaultProps.localeText,
    // MUI X no trae traducción gallega: se cae a la española, que es la más
    // cercana para quien elige gallego.
    gl: muiEsES.components.MuiLocalizationProvider.defaultProps.localeText,
    pt: muiPtPT.components.MuiLocalizationProvider.defaultProps.localeText,
    de: muiDeDE.components.MuiLocalizationProvider.defaultProps.localeText,
    fr: muiFrFR.components.MuiLocalizationProvider.defaultProps.localeText,
    mx: muiEsES.components.MuiLocalizationProvider.defaultProps.localeText,
};

// Current locale state (default to Spanish)
let currentLocale: Locale = es;
const defaultMuiLocaleText =
    muiEsES.components.MuiLocalizationProvider.defaultProps.localeText;
let currentLocaleText: PickersInputLocaleText = defaultMuiLocaleText;

/**
 * Get the current date-fns locale
 */
export function getDateLocale(): Locale {
    return currentLocale;
}

/**
 * Get the current MUI X date picker locale text
 */
export function getDatePickerLocaleText(): PickersInputLocaleText {
    return currentLocaleText;
}

/**
 * Set the date-fns locale based on language key
 */
export function setDateLocale(languageKey: string): void {
    currentLocale = localeMap[languageKey] || es;
    currentLocaleText = muiLocaleTextMap[languageKey] || defaultMuiLocaleText;
}

/**
 * Get date-fns locale from language key
 */
export function getLocaleFromKey(languageKey: string): Locale {
    return localeMap[languageKey] || es;
}

// Export all locales for direct use
export { es, enGB, ca, gl, pt, de, fr };
